/* tslint:disable */
/* eslint-disable */
/**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { BulkManualChangesResponseRecordingsInner } from './BulkManualChangesResponseRecordingsInner';
import {
    BulkManualChangesResponseRecordingsInnerFromJSON,
    BulkManualChangesResponseRecordingsInnerFromJSONTyped,
    BulkManualChangesResponseRecordingsInnerToJSON,
} from './BulkManualChangesResponseRecordingsInner';

/**
 * 
 * @export
 * @interface BulkManualChangesResponse
 */
export interface BulkManualChangesResponse {
    /**
     * 
     * @type {Array<BulkManualChangesResponseRecordingsInner>}
     * @memberof BulkManualChangesResponse
     */
    recordings: Array<BulkManualChangesResponseRecordingsInner>;
}

/**
 * Check if a given object implements the BulkManualChangesResponse interface.
 */
export function instanceOfBulkManualChangesResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "recordings" in value;

    return isInstance;
}

export function BulkManualChangesResponseFromJSON(json: any): BulkManualChangesResponse {
    return BulkManualChangesResponseFromJSONTyped(json, false);
}

export function BulkManualChangesResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): BulkManualChangesResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'recordings': ((json['recordings'] as Array<any>).map(BulkManualChangesResponseRecordingsInnerFromJSON)),
    };
}

export function BulkManualChangesResponseToJSON(value?: BulkManualChangesResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'recordings': ((value.recordings as Array<any>).map(BulkManualChangesResponseRecordingsInnerToJSON)),
    };
}

